import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const distributePoll = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.SOCIAL.DISTRIBUTE_POLL,
    data
  );
};

export default distributePoll;
